export const getAPI = () => {
  if (process.env.REACT_APP_API_HOST === 'local') return 'https://localhost:61361'
  if (process.env.REACT_APP_API_HOST === 'prd') return 'https://api.sciscore.asedasciences.com';
  return 'https://sciscore-api-dev.thewarriors3.com';
}